import client from './client';

// Kho file (Drive-like + bảng tính online). Riêng tư mặc định; quyền kiểm ở backend.
export const listDrive = (scope = 'mine', parent) =>
  client.get('/drive/list', { params: { scope, ...(parent ? { parent } : {}) } }).then((r) => r.data);
export const drivePeople = () => client.get('/drive/people').then((r) => r.data);
export const driveBreadcrumb = (parent) =>
  client.get('/drive/breadcrumb', { params: parent ? { parent } : {} }).then((r) => r.data);
export const createDrive = (payload) => client.post('/drive', payload).then((r) => r.data); // {kind,name,parent,data}
// Quét đơn PMBox theo khoảng ngày -> tạo bảng tính mới (fetch từ PMBox có thể lâu -> timeout rộng).
export const scanPmboxOrders = ({ from, to }) =>
  client.post('/drive/scan-pmbox', { from, to }, { timeout: 180000 }).then((r) => r.data);
export const openDrive = (id) => client.get(`/drive/${id}`).then((r) => r.data);

const apiBase = () => import.meta.env.VITE_API_URL || 'https://funnytask.net/api';
// NÉN GZIP thân request nếu trình duyệt hỗ trợ (CompressionStream) -> bảng lớn giảm ~9x dung lượng tải lên
// (1MB -> ~120KB) -> "Đang lưu" NHANH hơn nhiều trên mạng thật. express.json(inflate:true mặc định) TỰ giải
// nén theo Content-Encoding -> KHÔNG cần sửa backend. Trình duyệt cũ không có CompressionStream -> gửi thường.
async function gzipBlob(str) {
  try {
    if (typeof CompressionStream === 'undefined') return null;
    return await new Response(new Blob([str]).stream().pipeThrough(new CompressionStream('gzip'))).blob();
  } catch (e) { return null; }
}
// Lưu bảng tính: fetch + gzip (thay axios để nén được). Giữ xử lý 401 (hết phiên -> về đăng nhập) như client.js.
export async function saveDriveData(id, data) {
  const token = localStorage.getItem('ft_token') || '';
  const json = JSON.stringify({ data });
  const gz = await gzipBlob(json);
  const headers = { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
  if (gz) headers['Content-Encoding'] = 'gzip';
  const r = await fetch(`${apiBase()}/drive/${id}/data`, { method: 'PUT', headers, body: gz || json });
  if (r.status === 401) {
    localStorage.removeItem('ft_token');
    try { window.dispatchEvent(new CustomEvent('ft:auth-expired')); } catch { /* ignore */ }
    throw new Error('Hết phiên đăng nhập');
  }
  if (!r.ok) throw new Error('Lưu thất bại (' + r.status + ')');
  return r.json();
}
// Lưu bản CUỐI lúc rời trang (đóng tab/đóng app). fetch keepalive SỐNG SÓT qua unload — khác axios/XHR bị huỷ ngay.
// keepalive KHÔNG nén được (gzip là async, pagehide đồng bộ) + giới hạn ~64KB body (đủ cho "dán vài ô rồi đóng");
// bảng lớn thì bản lưu gzip NHANH trước đó (poll/blur/ẩn-trang) đã lo.
export function saveDriveDataBeacon(id, data) {
  try {
    const token = localStorage.getItem('ft_token') || '';
    return fetch(`${apiBase()}/drive/${id}/data`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
      body: JSON.stringify({ data }),
      keepalive: true,
    });
  } catch (e) { return null; }
}
export const lockDrive = (id) => client.post(`/drive/${id}/lock`).then((r) => r.data);
export const unlockDrive = (id) => client.post(`/drive/${id}/unlock`).then((r) => r.data);
export const updateDrive = (id, patch) => client.patch(`/drive/${id}`, patch).then((r) => r.data); // {name} | {parent}
export const starDrive = (id) => client.post(`/drive/${id}/star`).then((r) => r.data);
export const getDriveShares = (id) => client.get(`/drive/${id}/shares`).then((r) => r.data);
export const setDriveShares = (id, shares) => client.put(`/drive/${id}/shares`, { shares }).then((r) => r.data);
export const trashDrive = (id) => client.delete(`/drive/${id}`).then((r) => r.data);
export const restoreDrive = (id) => client.post(`/drive/${id}/restore`).then((r) => r.data);
export const purgeDrive = (id) => client.delete(`/drive/${id}/purge`).then((r) => r.data);
export const driveVersions = (id) => client.get(`/drive/${id}/versions`).then((r) => r.data);
export const restoreDriveVersion = (id, vid) => client.post(`/drive/${id}/versions/${vid}/restore`).then((r) => r.data);
export const driveCellLog = (id, params) => client.get(`/drive/${id}/cell-log`, { params }).then((r) => r.data);
